<template>
  <nav>
    <div id="nav-actions">
      <div class="group">
        <nav-button id="nav-btn-home" :label="homeButtonLabel" :title="homeButtonTitle" class="is-current" @click="handleHomeClick">
          <icon-home></icon-home>
        </nav-button>
      </div>
      <div class="group"></div>
      <div class="group">
        <nav-button id="nav-btn-log-out" :label="logOutButtonLabel" :title="logOutButtonTitle" @click="handleLogoutClick">
          <icon-logout></icon-logout>
        </nav-button>
      </div>
    </div>
    <div id="nav-handle">
      <button id="nav-btn-expand-collapse" :label="expandCollapseButtonLabel" disabled>
        <icon-handle></icon-handle>
      </button>
    </div>
  </nav>
</template>

<script>
import { URLS } from '@/utils/urls'
import navigation from '@/utils/navigation'
import { makeContinuationURL } from '@/utils'

import { mapActions } from 'vuex'

import NavButton from '@/components/common/Nav-Button'

import Home from '@/assets/icons/hubble-logo.svg?nodes'
import Logout from '@/assets/icons/hubble-ui.svg?log-out'
import Handle from '@/assets/icons/hubble-ui.svg?handle'

export default {
  components: {
    'icon-home': Home,
    'icon-logout': Logout,
    'icon-handle': Handle,
    'nav-button': NavButton
  },
  data () {
    return {
      homeButtonLabel: this.translate('navigaton home label'),
      homeButtonTitle: this.translate('navigaton home title'),
      logOutButtonLabel: this.translate('log out home label'),
      logOutButtonTitle: this.translate('log out home title'),
      expandCollapseButtonLabel: this.translate('expand and colapse label')
    }
  },
  methods: {
    ...mapActions('user', [
      'logout'
    ]),
    ...mapActions('search', [
      'goBackToRecentWorkspaces'
    ]),
    translate (string, object) {
      return this.$i18n.translate(string, object)
    },
    handleHomeClick () {
      if (this.$route.name === 'Home') {
        this.goBackToRecentWorkspaces()
      } else {
        navigation.go(URLS.App.Home())
      }
    },
    async handleLogoutClick () {
      try {
        // Attempt Logout
        await this.logout()
        // Use Router Navigation Guard to Handle Destination
        navigation.go(makeContinuationURL(this.$route))
      } catch (err) {
        // Report Error
        console.error('Logout errors occured:', JSON.stringify(err))
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/components/common/_sidebar.scss";
</style>
